<template lang="html">
  <div>
    <label>{{ title }}</label>
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        :style="`width: ${progress}%;`"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    progress: Number
  }
}
</script>

<style lang="css" scoped>
  .progress {
    height: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/ProgressBar.vue